<template>
  <select class="form-select form-select-lg" :aria-label="$t('header.dealerOrGroup')" v-model="selected">
    <option value="" disabled>
      {{ $t('header.dealerOrGroup') }}
    </option>
    <option v-for="(option, index) in businesses" :value="option.value" :key="index">
      {{ option.text }}
    </option>
  </select>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'BusinessesDropdown',
  computed: {
    ...mapState({
      userBusinesses: state => state.business.userBusinesses,
      currentBusinessId: state => (state.business.currentBusiness ? state.business.currentBusiness.id : null),
    }),
    selected: {
      get() {
        return this.currentBusinessId;
      },
      async set(selected) {
        if (selected !== this.currentBusinessId) {
          this.$store.commit('SET_GLOBAL_LOADING', true, { root: true });
          await this.updateCurrentBusiness(selected);
          if (this.$router.currentRoute.path !== '/dashboard') {
            window.location.href = '/dashboard';
          } else {
            window.location.reload();
          }
        }
      },
    },
    businesses() {
      return this.userBusinesses.reduce((businessArray, business) => {
        const obj = {
          value: business.id,
          text: business.name,
        };
        businessArray.push(obj);
        return businessArray;
      }, []);
    },
  },
  methods: {
    ...mapActions('business', ['updateCurrentBusiness']),
  },
};
</script>

<style scoped></style>
